import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-navtoggle', 'toggleMenu', 'Lülitage menüü sisse');
Labels.set('ui-navtoggle', 'closeMenu', 'Sulge menüü');
Labels.set('ui-navtoggle', 'close', 'Sulge');
